<template>
  <v-container>
    <v-row>
      <v-row>
        <v-col cols="12">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="searchQuery"
                label="Search address"
                @input="debouncedSearchLocation"
                prepend-icon="mdi-magnify"
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-list
              v-if="searchResults.length > 0"
              dense
              style="overflow-y: auto"
            >
              <v-list-item
                dense
                v-for="result in searchResults"
                :key="result.place_id"
                @click="selectLocation(result)"
              >
                <v-list-item-title>{{ result.display_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  data() {
    return {
      searchQuery: "",
      searchResults: [],
    };
  },
  methods: {
    debouncedSearchLocation: _.debounce(function () {
      this.searchLocation();
    }, 1000), // Debounce the search input by 250ms
    searchLocation() {
      if (this.searchQuery) {
        axios
          .get(
            `https://nominatim.openstreetmap.org/search?q=${this.searchQuery}&format=json`
          )
          .then((response) => {
            this.searchResults = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.searchResults = [];
      }
    },
    selectLocation(location) {
      this.$emit("selectLocation", location);
    },
  },
};
</script>
